import {useCallback, useState} from 'react';
import NavigationItem from './navigation-large/NavigationItem.jsx';
import {HOVER_DELAY_FIRST_LEVEL, HOVER_DELAY_SECOND_LEVEL} from './constants.js';
import NavigationLayer from './navigation-large/NavigationLayer.jsx';
import {useBreakpointUp} from 'bonprix-design-system';
import {NavigationFocusProvider} from '@header/scripts/components/context/NavigationFocusContext.jsx';
import {useNavigationKeyboard} from '@header/scripts/components/hooks/use-navigation-keyboard.js';

export default function NavigationLarge(props) {
    return (
        <NavigationFocusProvider>
            <NavigationLargeContent {...props} />
        </NavigationFocusProvider>
    );
}

function NavigationLargeContent({navigationItems, currentPage, texts}) {
    const [currentHoveredItemId, setCurrentHoveredItemId] = useState();

    const isShopActive = navigationItems.filter((item) => item.active).length === 1;
    const breakpointXlUp = useBreakpointUp('xl');

    let delayedExecutionTimeout;
    const delayedExecution = (cb) => {
        if (delayedExecutionTimeout) {
            clearTimeout(delayedExecutionTimeout);
        }
        delayedExecutionTimeout = setTimeout(() => {
            cb();
        }, HOVER_DELAY_FIRST_LEVEL);
    };

    const changeThirdLevelDelayedExecution = (cb, compareDate, initialOpen) => {
        if (delayedExecutionTimeout) {
            // clear the timeout if a new command comes in
            clearTimeout(delayedExecutionTimeout);
        }
        // no delay needed if the layer is opening for the first time
        const hoverDelay = initialOpen ? 0 : HOVER_DELAY_SECOND_LEVEL;

        // calculate remaining delay time so that the delay is always consistent
        const remainingDelayTime = hoverDelay - (new Date() - compareDate);
        if (remainingDelayTime > 0) {
            delayedExecutionTimeout = setTimeout(() => {
                cb();
            }, remainingDelayTime);
        } else {
            cb();
        }
    };

    const currentNavigationItem = currentHoveredItemId
        ? navigationItems.find((item) => item.id === currentHoveredItemId)
        : null;

    const handlePointerEnter = () => {
        setTimeout(() => {
            delayedExecution(() => {});
        }, 0);
    };

    const handlePointerLeave = () => {
        delayedExecution(() => {
            setCurrentHoveredItemId(undefined);
        });
    };

    const closeLayer = useCallback(() => {
        setCurrentHoveredItemId(undefined);
    }, []);

    useNavigationKeyboard(currentHoveredItemId, closeLayer);

    const navigationClassName = `navigation__level -level:first ${breakpointXlUp ? '' : '-hide'}`;
    return (
        <>
            <ul className={navigationClassName}>
                {navigationItems.map((item) => (
                    <NavigationItem
                        key={item.id}
                        navigationItem={item}
                        setCurrentHoveredItemId={setCurrentHoveredItemId}
                        currentHoveredItemId={currentHoveredItemId}
                        isShopActive={isShopActive}
                        delayedExecution={delayedExecution}
                    />
                ))}
            </ul>
            {currentNavigationItem && (
                <NavigationLayer
                    currentPage={currentPage}
                    texts={texts}
                    secondLevelNavigationItems={currentNavigationItem.subNavigationItems}
                    changeThirdLevelItemsWithHoverDelay={changeThirdLevelDelayedExecution}
                    onHandlePointerEnter={handlePointerEnter}
                    onHandlePointerLeave={handlePointerLeave}
                    onHandleCloseLayer={closeLayer}
                />
            )}
        </>
    );
}
